import _ from 'lodash';
import {
	AnalyticsDataProps,
	EventDataProps,
	Vehicle,
	Event,
	EventData
} from '../@types/analyticsTypes';
import { ANALYTICS_CONSTANTS } from '../constants/analytics';

const {
	CHANNEL,
	TOPIC,
	COMPONENT_NAME,
	COMPONENT_GROUP,
	STEPS: { TYPE_VIN, VIN_FOUND, ERROR },
	EVENTS: { COMPONENT_EVENT }
} = ANALYTICS_CONSTANTS;

export const publishBaseAnalyticsDataToDataLayer = ({
	eventData
}: EventData): void => {
	if (_.isEmpty(eventData)) {
		return;
	}
	// eslint-disable-next-line no-restricted-syntax
	console.log({
		channel: CHANNEL,
		topic: TOPIC,
		data: {
			extraData: eventData
		}
	});
	return window.postal.publish({
		channel: CHANNEL,
		topic: TOPIC,
		data: {
			extraData: eventData
		}
	});
};

const buildEvent = (action: string, eventLabel: string): Event => {
	const name = COMPONENT_EVENT;

	return {
		name,
		componentName: COMPONENT_NAME,
		componentGroup: COMPONENT_GROUP,
		action,
		label: eventLabel
	};
};

const getAnalyticsData = ({
	label,
	action
}: AnalyticsDataProps): EventDataProps | null => {
	const event = buildEvent(action, label);

	return _.omitBy(
		{
			event
		},
		_.isNil
	);
};

export const publishStepAnalyticsData = ({
	label,
	action
}: AnalyticsDataProps): void => {
	const data = getAnalyticsData({
		label,
		action
	});
	if (data) {
		const eventData: EventDataProps = data;
		publishBaseAnalyticsDataToDataLayer({ eventData });
	}
};
// eslint-disable-next-line max-lines-per-function
export const setAnalyticsHelper = (
	step: string,
	vehicle?: Vehicle,
	error?: string
): void => {
	let label, action;

	switch (step) {
		case TYPE_VIN:
			action = TYPE_VIN;
			break;
		case VIN_FOUND:
			label = vehicle?.model;
			action = VIN_FOUND;
			break;
		default:
			label = error;
			action = ERROR;
			break;
	}

	publishStepAnalyticsData(
		_.omitBy(
			{
				action: action,
				label
			},
			_.isNil
		) as AnalyticsDataProps
	);
};
